"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["Prestep_ExternalAccountAlreadyConnected"] = "Prestep_ExternalAccountAlreadyConnected";
  TranslationKey["Prestep_InvitationCodeNotFound"] = "Prestep_InvitationCodeNotFound";
  TranslationKey["Prestep_RegistrationFailed"] = "Prestep_RegistrationFailed";
  TranslationKey["Prestep_UnauthorizedAccess"] = "Prestep_UnauthorizedAccess";
  TranslationKey["birthDate_DoesntMatchUniqueId"] = "birthDate_DoesntMatchUniqueId";
  TranslationKey["birthDate_LegalRequirementsFailed"] = "birthDate_LegalRequirementsFailed";
  TranslationKey["birthDate_OutOfRange"] = "birthDate_OutOfRange";
  TranslationKey["customer_NotEligible"] = "customer_NotEligible";
  TranslationKey["customer_NotUnique"] = "customer_NotUnique";
  TranslationKey["document_ExpirationTooSoon"] = "document_ExpirationTooSoon";
  TranslationKey["errorOccured"] = "errorOccured";
  TranslationKey["fileTypeIsNotSupported"] = "fileTypeIsNotSupported";
  TranslationKey["loginLinkLabel"] = "loginLinkLabel";
  TranslationKey["passwordRequirementCharactersCount"] = "passwordRequirementCharactersCount";
  TranslationKey["passwordRequirementDigit"] = "passwordRequirementDigit";
  TranslationKey["passwordRequirementLetter"] = "passwordRequirementLetter";
  TranslationKey["passwordRequirementLowerCaseLetter"] = "passwordRequirementLowerCaseLetter";
  TranslationKey["passwordRequirementSpecialCharacter"] = "passwordRequirementSpecialCharacter";
  TranslationKey["passwordRequirementUpperCaseLetter"] = "passwordRequirementUpperCaseLetter";
  TranslationKey["sponsorChangeBlockedSponsor"] = "sponsorChangeBlockedSponsor";
  TranslationKey["sponsorChangeNotExistingSponsor"] = "sponsorChangeNotExistingSponsor";
  TranslationKey["termsAndConditions_Mandatory"] = "termsAndConditions_Mandatory";
  TranslationKey["validationBirthDateRegex"] = "validationBirthDateRegex";
  TranslationKey["validationDateRegex"] = "validationDateRegex";
  TranslationKey["validationEmailIsAlreadyUsed"] = "validationEmailIsAlreadyUsed";
  TranslationKey["validationEmailTerminatedCustomer"] = "validationEmailTerminatedCustomer";
  TranslationKey["validationLength"] = "validationLength";
  TranslationKey["validationMandatoryPropertyIsNull"] = "validationMandatoryPropertyIsNull";
  TranslationKey["validationMaxLength"] = "validationMaxLength";
  TranslationKey["validationMaxSize"] = "validationMaxSize";
  TranslationKey["validationMaxValue"] = "validationMaxValue";
  TranslationKey["validationMinLength"] = "validationMinLength";
  TranslationKey["validationMinValue"] = "validationMinValue";
  TranslationKey["validationRegex"] = "validationRegex";
  TranslationKey["validationRegexBirthDate"] = "validationRegexBirthDate";
  TranslationKey["validationRegexEmail"] = "validationRegexEmail";
  TranslationKey["validationRegexIdentityCardDateExpiration"] = "validationRegexIdentityCardDateExpiration";
  TranslationKey["validationRegexPhone"] = "validationRegexPhone";
  TranslationKey["validationRegexUniqueID"] = "validationRegexUniqueID";
  TranslationKey["validationRequired"] = "validationRequired";
  TranslationKey["validationSingleFile"] = "validationSingleFile";
  TranslationKey["validationUniqueAlias"] = "validationUniqueAlias";
  TranslationKey["validationUniqueBankAccount"] = "validationUniqueBankAccount";
  TranslationKey["validationUniqueCustomerAttribute"] = "validationUniqueCustomerAttribute";
  TranslationKey["validationUniqueDisplayName"] = "validationUniqueDisplayName";
  TranslationKey["validationUniquePhone"] = "validationUniquePhone";
  TranslationKey["validationUniqueTaxCode"] = "validationUniqueTaxCode";
  TranslationKey["validationUniqueTaxCode2"] = "validationUniqueTaxCode2";
  TranslationKey["validationUniqueUniqueId"] = "validationUniqueUniqueId";
  TranslationKey["validationValidConfirmationCode"] = "validationValidConfirmationCode";
  TranslationKey["validationValidOldPassword"] = "validationValidOldPassword";
  TranslationKey["validationValidPhone"] = "validationValidPhone";
  TranslationKey["validationValidSponsorNumber"] = "validationValidSponsorNumber";
  TranslationKey["validationValidUniqueId"] = "validationValidUniqueId";
  TranslationKey["validationXmlCharacters"] = "validationXmlCharacters";
  TranslationKey["validationZipCodeStructure"] = "validationZipCodeStructure";
  return TranslationKey;
}({});
//# sourceMappingURL=TranslationKey.js.map